import { handleActions } from 'redux-actions';
import { v4 as uuidv4 } from 'uuid';

import { resourceStoreTypes, resourceUpserters } from '../core';
import { undoActions, undoTypes } from '../undo';

import * as actions from './preferencesV2Actions';
import { isValidJSON } from './preferencesV2Utils';

const preferencesV2Reducer = handleActions(
  {
    [actions.getPreferencesV2]: (state) => state.merge({ isLoading: true }),
    [actions.getPreferencesV2Success]: (state, { payload }) => resourceUpserters.upsertResources(state, payload),
    [actions.getPreferencesV2Failure]: (state, { payload: error }) => resourceUpserters.completeWithError(state, error),

    [actions.getSpecificPreferenceV2]: (state, { payload }) => resourceUpserters.upsertResource(state, payload),
    [actions.getSpecificPreferenceV2Success]: (state, { payload }) => resourceUpserters.upsertResources(state, payload),
    [actions.getSpecificPreferenceV2Failure]: (state, { payload: error }) =>
      resourceUpserters.completeWithError(state, error),

    [actions.updatePreferenceOverride]: (state, { payload, meta }) => {
      if (meta?.axiosConfig) {
        return state;
      }
      if (payload?.dataType && (payload?.dataType === 'JSON' || payload?.dataType === 'ARRAY')) {
        if (isValidJSON(payload.value)) {
          return resourceUpserters.upsertResource(state, payload);
        }
        return state;
      }
      return resourceUpserters.upsertResource(state, payload);
    },
    [actions.updatePreferenceOverrideSuccess]: (state, { payload }) =>
      resourceUpserters.upsertResources(state, payload),
    [actions.updatePreferenceOverrideFailure]: (state, { payload: error }) =>
      resourceUpserters.completeWithError(state, error),

    [actions.updatePreferenceCriteriaSuccess]: (state, { meta, asyncDispatch }) => {
      const undo = undoTypes.mkUndo({
        userMessage: meta?.undo?.userMessage,
        key: uuidv4(),
      });
      asyncDispatch(undoActions.addUndo(undo));
      asyncDispatch(actions.getPreferencesV2());
      return state;
    },
    [actions.resetPreferenceOverride]: (state, { payload }) => {
      const alteredPayload = { ...payload, value: payload.defaultValue };
      return resourceUpserters.upsertResource(state, alteredPayload);
    },
  },
  resourceStoreTypes.mkQcsSyncResourceStore(),
);

export const PREFERENCES_V2_REDUCER_KEY = 'preferencesV2Store';
export default preferencesV2Reducer;
